import { render, staticRenderFns } from "./EsimProfileGroupList.vue?vue&type=template&id=88493c54&"
import script from "./EsimProfileGroupList.vue?vue&type=script&lang=js&"
export * from "./EsimProfileGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports